import React from 'react';
import { customEvents } from '../../../../../utils/dom';
import { notify } from '../../../notifications/util';
import ModalManager from './ModalManager';
import { TDispatchedNotification } from '@apia/notifications';

export default function useModalManager(props?: {
  initialTitle?: string;
  onClose?: () => unknown;
}) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [ref, setRef] = React.useState<HTMLIFrameElement | null>(null);
  const [title, setTitle] = React.useState(props?.initialTitle ?? '');

  React.useEffect(() => {
    if (ref) {
      const innerHandleClose = () => {
        props?.onClose?.();
      };
      const innerHandleChangeTitle = (ev: Event) => {
        setTitle((ev as CustomEvent<{ newTitle: string }>).detail.newTitle);
      };
      const innerHandleNotify = (ev: Event) => {
        notify(
          (ev as CustomEvent<{ notification: TDispatchedNotification }>).detail
            .notification,
        );
      };
      const handleKeyDown = (ev: KeyboardEvent) => {
        if (ev.code === 'Escape') ref?.modalManager.onPressEscape(ev);
      };

      ref.onload = () => {
        if (ref.contentWindow && ref.contentDocument) {
          ref.modalManager = new ModalManager(ref);
          setIsLoading(false);

          ref.contentWindow.onbeforeunload = () => {
            setIsLoading(true);
          };

          setTimeout(() => {
            ref.contentDocument?.body.addEventListener(
              'keydown',
              handleKeyDown,
            );
          }, 0);
        }
      };

      ref.addEventListener(customEvents.iframeModalClose, innerHandleClose);
      ref.addEventListener(
        customEvents.iframeModalChangeTitle,
        innerHandleChangeTitle,
      );
      ref.addEventListener(customEvents.iframeModalNotify, innerHandleNotify);

      return () => {
        ref.contentDocument?.body.removeEventListener('keydown', handleKeyDown);
        ref.removeEventListener(
          customEvents.iframeModalClose,
          innerHandleClose,
        );
        ref.removeEventListener(
          customEvents.iframeModalChangeTitle,
          innerHandleChangeTitle,
        );
        ref.removeEventListener(
          customEvents.iframeModalNotify,
          innerHandleNotify,
        );
      };
    }
    return () => {};
  }, [props, ref]);

  return { isLoading, title, ref, setRef };
}
